//@sample-repo
import Vue from 'vue'

const url = Vue.prototype.$config.api_url + Vue.prototype.$config.research.researcher

const research = {
  create(payload:any) {
  },
  edit(id:string|number,payload:any) {
    let URL= url+`/${id}`
    return Vue.prototype.$httpService.put(URL,payload)
  },
  find(id:string|number) {

  },
  partial_edit(id:string|number,payload:any){
    let URL = Vue.prototype.$config.api_url + Vue.prototype.$config.research.base+`/${id}`
   return Vue.prototype.$httpService.patch(URL,payload)
  },
  delete(id:string|number) {
    let URL = url+`/${id}`
   return Vue.prototype.$httpService.delete(URL)
  },
  list(params = {}) {
  }
}

export default research;

